import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Button from "src/components/Button";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import AuthLayout, {
	AuthLayoutContainer,
} from "src/components/layout/auth-layout/AuthLayout";
import Loader from "src/components/Loader";
import useCampaign from "src/hooks/api/services/auth/useCampaign";

function CampaignUnsubscribeView({ t }: Translation) {
	const params = useParams();
	const { campaign, status, actions } = useCampaign({
		id: params.id as string,
	});
	const [isUnsubscribed, setIsUnsubscribed] = useState(false);

	useEffect(() => {
		actions.get();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (status !== "idle") {
		return (
			<AuthLayout variant="flat">
				<AuthLayoutContainer className="flex justify-center items-center h-full">
					<Loader />
				</AuthLayoutContainer>
			</AuthLayout>
		);
	}

	return (
		<AuthLayout variant="flat">
			{campaign?.id && (
				<AuthLayoutContainer className="md:pt-0 pt-0">
					<div className="flex flex-col max-w-md mx-auto w-full">
						{isUnsubscribed && (
							<div className="flex flex-col items-center justify-center mb-4 bg-green text-white p-3 rounded-md">
								<span>{t("success")}</span>
							</div>
						)}

						<div className="flex flex-col my-8">
							<h1 className="text-2xl mb-1">{t("title")}</h1>
							<p className="opacity-70">{t("description")}</p>
						</div>
						<Button
							onClick={() => {
								return actions.unsubscribe().then(() => {
									setIsUnsubscribed(true);
								});
							}}
						>
							{t("unsubscribe")}
						</Button>
					</div>
				</AuthLayoutContainer>
			)}
		</AuthLayout>
	);
}

CampaignUnsubscribeView.locale = {
	nl: {
		success: "Je bent afgemeld voor onze e-mails",
		title: "Afmelden voor e-mails",
		description:
			"We vinden het jammer dat je je wilt afmelden. Laat ons weten of er iets is dat we kunnen verbeteren. Je kunt je hieronder afmelden door op de knop 'Afmelden' te klikken.",
		unsubscribe: "Afmelden",
	},
	en: {},
};
export default withTranslation(CampaignUnsubscribeView);
